import { DAY_NAMES_LONG, DAY_NAMES_NARROW, DAY_NAMES_SHORT, DayNameNarrow } from '@/constants'

const DAY_NAME_MAP = {
  long: DAY_NAMES_LONG,
  narrow: DAY_NAMES_NARROW,
  short: DAY_NAMES_SHORT,
} as const

// Note: Format is -> Sunday | Sun | Sn
export const formatWeekday = (
  day: DayNameNarrow,
  format: Intl.DateTimeFormatOptions['weekday'] = 'long',
): string => {
  const index = DAY_NAMES_NARROW.indexOf(day)
  return DAY_NAME_MAP[format][index]
}
